export function isStrategyResolver(value) {
    return value && value.strategy && value.get;
}
export function isResolver(value) {
    return value.get && typeof value.get === 'function';
}
export var Strategy;
(function (Strategy) {
    Strategy[Strategy["Unset"] = -1] = "Unset";
    Strategy[Strategy["Instance"] = 0] = "Instance";
    Strategy[Strategy["Singleton"] = 1] = "Singleton";
    Strategy[Strategy["Transient"] = 2] = "Transient";
    Strategy[Strategy["Function"] = 3] = "Function";
    Strategy[Strategy["Array"] = 4] = "Array";
    Strategy[Strategy["Alias"] = 5] = "Alias";
    Strategy[Strategy["Scoped"] = 6] = "Scoped";
})(Strategy || (Strategy = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ0eXBlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUErQkEsTUFBTSxVQUFVLGtCQUFrQixDQUFDLEtBQVU7SUFDekMsT0FBTyxLQUFLLElBQUksS0FBSyxDQUFDLFFBQVEsSUFBSSxLQUFLLENBQUMsR0FBRyxDQUFDO0FBQ2hELENBQUM7QUFLRCxNQUFNLFVBQVUsVUFBVSxDQUFDLEtBQVU7SUFDakMsT0FBTyxLQUFLLENBQUMsR0FBRyxJQUFJLE9BQU8sS0FBSyxDQUFDLEdBQUcsS0FBSyxVQUFVLENBQUM7QUFDeEQsQ0FBQztBQUVELE1BQU0sQ0FBTixJQUFZLFFBU1g7QUFURCxXQUFZLFFBQVE7SUFDaEIsMENBQVUsQ0FBQTtJQUNWLCtDQUFZLENBQUE7SUFDWixpREFBYSxDQUFBO0lBQ2IsaURBQWEsQ0FBQTtJQUNiLCtDQUFZLENBQUE7SUFDWix5Q0FBUyxDQUFBO0lBQ1QseUNBQVMsQ0FBQTtJQUNULDJDQUFVLENBQUE7QUFDZCxDQUFDLEVBVFcsUUFBUSxLQUFSLFFBQVEsUUFTbkIifQ==